import React, { memo } from 'react';
import styles from './styles.module.scss';

const FieldItem = ({ data, index, style, children: Children }) => (
  <div className={ styles.listItem } style={ style }>
    <Children data={ data } rowIndex={ index } />
  </div>
);

export default memo(FieldItem);
